import React, { useState } from 'react';
import Layout from '../../Components/Layout';
import { Box, Typography, Tabs, Tab, Paper } from '@mui/material';
import Appearance from './components/Appearance';
import Installation from './components/Installation';
import { ColorLens as ColorLensIcon, GetApp as GetAppIcon, InstallDesktop as InstallDesktopIcon, Build as BuildIcon } from '@mui/icons-material';

function TabPanel({ children, value, index, ...other }) {
  return (
    <div role="tabpanel" hidden={value !== index} id={`widget-tabpanel-${index}`} aria-labelledby={`widget-tab-${index}`} {...other}>
      {value === index && <Box sx={{ pt: 3 }}>{children}</Box>}
    </div>
  );
}

function WidgetIndex() {
  const [tabValue, setTabValue] = useState(0);
  return (
    <Layout>
      <Box sx={{ mt: 3, px: 2 }}>
        {/* Header Section with Title and Description */}
        <Box sx={{ 
           display: 'flex', 
           justifyContent: 'space-between', 
           alignItems: 'flex-start',
           mb: 3,
           flexDirection: { xs: 'column', sm: 'row' },
           gap: { xs: 2, sm: 0 }
         }}>
           {/* Left Side - Title and Description */}
           <Box sx={{ flex: 1 }}>
             <Typography variant="h5" sx={{ 
               fontWeight: 700, 
               mb: 1,
               fontSize: { xs: '1.5rem', sm: '2rem' },
               color: '#111827'
             }}>
               Widget Management
             </Typography>
             {/* <Typography variant="body2" sx={{ 
               color: '#6b7280',
               fontSize: { xs: '14px', sm: '16px' },
               lineHeight: 1.5
             }}>
               Manage suggested questions for your AI widget
             </Typography> */}
           </Box>
         </Box>
        <Paper sx={{ width: '100%', mb: 2 }}>
          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <Tabs value={tabValue} onChange={(e, v) => setTabValue(v)} variant="scrollable" scrollButtons="auto"
              sx={{ '& .MuiTab-root': { textTransform: 'none', fontWeight: 600, fontSize: { xs: '12px', sm: '14px' }, minHeight: { xs: '40px', sm: '48px' }, px: { xs: 1, sm: 2 }, minWidth: { xs: 'auto', sm: 'auto' } }, '& .Mui-selected': { color: '#374151' }, '& .MuiTabs-scrollButtons': { display: { xs: 'flex', sm: 'none' } } }}>
              <Tab label="Appearance" icon={<ColorLensIcon sx={{ fontSize: { xs: 18, sm: 20 } }} />} iconPosition="start" />
              <Tab label="Installation" icon={<InstallDesktopIcon sx={{ fontSize: { xs: 18, sm: 20 } }} />} iconPosition="start" />
            </Tabs>
          </Box>
        </Paper>
        <TabPanel value={tabValue} index={0}>
          <Appearance />
        </TabPanel>
        <TabPanel value={tabValue} index={1}>
          <Installation />
        </TabPanel>
      </Box>
    </Layout>
  );
}

export default WidgetIndex;


